import errorMessages from 'utils/validation/errorMessages';
import * as Yup from 'yup';

export const validationTherapistSchema = Yup.object().shape({
  therapists: Yup.array()
    .of(
      Yup.object().shape({
        lastname: Yup.mixed()
          .required('Last name is required')
          .test('is-valid', 'Please select a valid therapist', value => {
            // If it's an object from select, validate label/value presence
            if (typeof value === 'object') {
              return value?.label && value?.value;
            }
            // If it's just a string value
            return !!value;
          }),
        firstname: Yup.string().required(errorMessages?.required),
        email: Yup.string()
          .email(errorMessages?.email)
          .required(errorMessages?.required),
        service: Yup.array()
          .min(1, 'Please select at least one service')
          .required('This field required')
      })
    )
    .min(1, 'At least one therapist is required')
});
